<template>
  <!--
    Official QuickBooks logomark — circle with the interlocked qb letterform.
    Paths sourced directly from the official Intuit SVG asset.
    Connected: #2CA01C green | Disconnected: #9CA3AF gray
  -->
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 128 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <!-- Circle background — green when linked, gray when not -->
    <path
      d="M64 128c35.346 0 64-28.654 64-64S99.346 0 64 0 0 28.654 0 64s28.654 64 64 64z"
      :fill="connected ? '#2CA01C' : '#9CA3AF'"
    />
    <!-- qb letterform in white — exact official paths -->
    <path
      d="M17.778 64a24.889 24.889 0 0 0 24.889 24.889h3.555v-9.245h-3.555a15.645 15.645 0 1 1 0-31.289H51.2v48.356a9.248 9.248 0 0 0 9.244 9.245V39.111H42.667A24.889 24.889 0 0 0 17.777 64zm67.555-24.889h-3.555v9.245h3.555a15.645 15.645 0 0 1 0 31.288H76.8V31.29a9.244 9.244 0 0 0-9.244-9.245V88.89h17.777a24.888 24.888 0 0 0 0-49.778z"
      fill="#fff"
    />
  </svg>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  connected?: boolean;
  size?: number | string;
}>(), {
  connected: false,
  size: 24,
});
</script>
